export default {"src":"/_next/static/media/scene-enhance.7be3fe05.svg","height":36,"width":36};